import React, { Component, ErrorInfo } from 'react'

type IProps = {}

interface IState {
  error: Error | null
  hasError: boolean
}

export class StudioErrorBoundary extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error) {
    return { error, hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return <h1>Studio has encountered an error.</h1>
    }

    return this.props.children
  }
}
